import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
import 'animate.css/animate.min.css'

import style from '../styles/masters.module.css'

import React from 'react'
import { graphql } from 'gatsby'
import $ from 'jquery';

import SEO from "../components/seo"

import { formatDate } from '../utils';
import locations from '../data/locations.json'

const TILE_URLS = {
    BASE: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
};
const VWORLD_ATTRIBUTION = '&copy; <a href="http://www.vworld.kr/po_main.do" target="_blank">공간정보 오픈플랫폼</a>'
    + ' | <a href="http://www.molit.go.kr/" target="_blank">국토교통부</a>';

const CONTENT_SEPARATOR = '-----';

class MastersPage extends React.Component {

    constructor(props) {
        super(props);

        let settings = {
            minZoom: 7,
            maxZoom: 18,
            bounds: [[32.5, 125], [39, 130.5]],
            maxBoundsViscosity: .8,
            zoomControl: false,
            zoomSnap: 1,
        };

        this.state = {
            settings,
            locations
        };

        if (global.navigator && global.navigator.geolocation) {
            global.navigator.geolocation.getCurrentPosition(loc => {
                settings.center = [loc.coords.latitude, loc.coords.longitude];
                settings.zoom = 14;
                this.setState({settings});
            });
        } else {
            settings.bounds = [[32.5, 125], [39, 130.5]];
            settings.maxBounds = [[31, 122], [40, 134]];
            this.setState({settings});
        }

        this.contentFileUrl = props.data.contentFile.publicURL;
    }

    componentDidMount() {
        setTimeout(function() {
            $('#divInfo, #divInfoTouch').fadeOut('fast');
        }, 10000);

        $('#divInfoTouch, #divInfo').on('mousedown touchdown', function() {
            $('#divInfo, #divInfoTouch').fadeOut('fast');
        });

        if (global.window) {
            fetch(this.contentFileUrl).then(response => response.text()).then(data => this.setState({textContent: data}));
        }
    }

    scrollIntoView = idx => {
        setTimeout(() => {
            console.log('.' + style.contentHighlight)
            let el = $('.' + style.contentHighlight)[0];
            if (el) {
                el.scrollIntoView(false);
                el.parentNode.scrollTop += 150;
            }
        }, 200);
    }

    render() {
        let map;
        
        if (global.window) {
            const { Map, TileLayer, Marker, Popup } = require('react-leaflet');
            const MarkerClusterGroup = require('react-leaflet-markercluster').default;
            require('leaflet-defaulticon-compatibility');
            const textContent = this.state.textContent;

            map = (
                <Map className={style.map} {...this.state.settings}>
                    <TileLayer 
                        url={TILE_URLS.BASE} opacity="1"
                        attribution={VWORLD_ATTRIBUTION}
                    />

                    <MarkerClusterGroup>
                    {
                        this.state.locations.list.map((l, idx) => {
                            let content;

                            if (textContent) {
                                const textIndex = l.index;
                                let blockStart = textContent.lastIndexOf(CONTENT_SEPARATOR, textIndex);
                                if (blockStart < 0)
                                    blockStart = 0;
                                else
                                    blockStart += CONTENT_SEPARATOR.length;
                                let blockEnd = textContent.indexOf(CONTENT_SEPARATOR, textIndex);
                                let lineStart = textContent.lastIndexOf('\n', textIndex);
                                if (lineStart < 0)
                                    lineStart = 0;
                                else
                                    lineStart += 1;
                                let lineEnd = textContent.slice(textIndex).search(/\r?\n/);
                                if (lineEnd < 0)
                                    lineEnd = blockEnd;
                                else
                                    lineEnd += textIndex;
                
                                content = (
                                    <>
                                        {textContent.slice(blockStart, lineStart)}
                                        <span className={style.contentHighlight}>
                                            {textContent.slice(lineStart, lineEnd)}
                                        </span>
                                        {textContent.slice(lineEnd, blockEnd)}
                                    </>
                                );
                            }
            
                            return (
                                <Marker key={idx}
                                    position={[l.lat, l.lng]}
                                    title={l.address}
                                >
                                    <Popup
                                        className={style.popupContent} maxHeight="320"
                                        onOpen={() => this.scrollIntoView(idx)}
                                    >
                                        {content}
                                    </Popup>
                                </Marker>
                            );
                        })
                    }
                    </MarkerClusterGroup>
                </Map>
            );
        }

        return (
            <>
                <SEO
                    title="달인의 추억"
                    description="SBS 생활의 달인 지도. 방송에 나온 맛집, 멋집 찾기."
                />

                <div>{map}</div>

                <div id="divInfoTouch" className={style.mapInfoTouch}></div>

                <div id="divInfo" className={style.mapInfo}>
                    <div className="animate__animated animate__rubberBand"><h1>달인의 추억</h1></div>
                    <div className="desc">
                        <p>전국 생활의 달인 지도로 찾기 ({formatDate(this.state.locations.updated)})</p>
                    </div>
                    <div className={style.finePrint}>
                        <p>이 페이지는 SBS 생활의 달인 방송을 시청하는
                            시청자로서 제작한 웹페이지입니다.</p>
                        <p style={{textAlign: 'center'}}>(c) 2017-2021 <a href="http://feeva.github.io/">이동련</a></p>
                    </div>
                </div>
            </>
        )
    }
}

export const query = graphql`
    query {
        contentFile: file(relativePath: { eq: "content.txt" }) {
            name
            publicURL
        }
    }
`

export default MastersPage
